import { BlocksIconList } from 'blocks-nextjs/blocks-web-components/components/icon/icons/list';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconList = createComponent({ react: React, tagName: 'cat-icon-list', elementClass: BlocksIconList });
